module.exports = __webpack_public_path__ + "static/langojango-croatian-language-phrasebook-5ae7096f48437239f802f27752e7fe09.png";